import { render, staticRenderFns } from "./ui-slider.vue?vue&type=template&id=1b4e27f2&scoped=true&"
import script from "./ui-slider.vue?vue&type=script&lang=js&"
export * from "./ui-slider.vue?vue&type=script&lang=js&"
import style0 from "./ui-slider.vue?vue&type=style&index=0&id=1b4e27f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e27f2",
  null
  
)

export default component.exports